export default __webpack_public_path__ + "src/assets/not-included-in-block.fce8ccadf8ed532fbdbbaa4f63cf3b43.svg";